var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPyp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 11.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#252525;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.2,12H.89a1.12,1.12,0,0,1-.66-.4A1.45,1.45,0,0,1,0,11.05V.91A1,1,0,0,1,1.08,0h6a1,1,0,0,1,.7.26c.34.32.66.66,1,1a1.18,1.18,0,0,1,.36.9V4.84l.11-.1c.36-.35.69-.71,1.07-1a1,1,0,0,1,1-.14,1,1,0,0,1,.65.79,1.1,1.1,0,0,1-.34,1L9.24,7.71a.35.35,0,0,0-.1.24v2.93a1,1,0,0,1-.43.9A2.75,2.75,0,0,1,8.2,12ZM6.32.71H1.11A.35.35,0,0,0,.7,1v9.85c0,.29.13.42.42.42H8c.29,0,.42-.13.42-.42V8.55l-.23.11-1.37.46a.37.37,0,0,1-.5-.1.36.36,0,0,1,0-.4c.16-.45.3-.91.46-1.36A.63.63,0,0,1,6.93,7l1.4-1.4a.28.28,0,0,0,.08-.2V2.81H6.71A.36.36,0,0,1,6.3,2.5a.17.17,0,0,1,0-.1V.71ZM8.17,6.8l.47.47,1.65-1.65-.47-.46ZM7,2.1h1.4a.38.38,0,0,0-.11-.3l-1-1A.29.29,0,0,0,7,.7Zm3.31,2.5.5.5.34-.35a.35.35,0,0,0-.5-.5h0ZM7.64,7.31c-.3.23-.28.61-.42.91.31-.14.69-.11.91-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.22,3.5H6.64A.35.35,0,0,1,7,3.82.29.29,0,0,1,7,4a.36.36,0,0,1-.3.22H1.85c-.28,0-.44-.13-.44-.35s.16-.37.44-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,4.92H5.24a.34.34,0,0,1,.38.32.25.25,0,0,1,0,.17.35.35,0,0,1-.33.22H1.79a.36.36,0,0,1-.38-.32.25.25,0,0,1,0-.15.37.37,0,0,1,.36-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,7H1.78a.35.35,0,0,1-.35-.21.35.35,0,0,1,.07-.38.39.39,0,0,1,.31-.11h3.4a.35.35,0,0,1,.41.29A.34.34,0,0,1,5.33,7a.24.24,0,0,1-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,7.73H5.24a.34.34,0,0,1,.38.32.29.29,0,0,1,0,.18.33.33,0,0,1-.33.21H1.79a.35.35,0,0,1-.39-.31.32.32,0,0,1,0-.19.36.36,0,0,1,.36-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.62,10.58h-1a.34.34,0,0,1-.39-.31.36.36,0,0,1,.31-.39H6.62a.37.37,0,0,1,.4.31.36.36,0,0,1-.31.39H5.62Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyp);
export default __webpack_public_path__ + "static/media/pyp.8ca076d5f04dd82b94bf129a2b47dc81.svg";
export { ForwardRef as ReactComponent };